exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-data-bank-dataset-detail-header-___header__header___2q0jb {\n  display: flex;\n  font-size: 14px;\n  flex-direction: row;\n  padding: 18px 36px;\n  color: #272727;\n}\n\n.src-components-data-bank-dataset-detail-header-___header__content___2Xg1a {\n  flex: 1;\n}\n\n.src-components-data-bank-dataset-detail-header-___header__name___2IKei {\n  font-size: 24px;\n  text-align: left;\n  line-height: 24px;\n  font-weight: 100;\n  margin-bottom: 4px;\n}\n\n.src-components-data-bank-dataset-detail-header-___header__provider___1z1oZ {\n  font-size: 13px;\n  color: #909090;\n  padding-left: 1px;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 750px) {\n  .src-components-data-bank-dataset-detail-header-___header__name___2IKei {\n    font-size: 22px;\n  }\n}", ""]);

// exports
exports.locals = {
	"header": "src-components-data-bank-dataset-detail-header-___header__header___2q0jb",
	"content": "src-components-data-bank-dataset-detail-header-___header__content___2Xg1a",
	"name": "src-components-data-bank-dataset-detail-header-___header__name___2IKei",
	"provider": "src-components-data-bank-dataset-detail-header-___header__provider___1z1oZ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/data-bank/dataset-detail/header/header.scss
// module id = 1838
// module chunks = 0